export default {
  modalConfiguration: {
    title: 'Configuration des moteurs de calculs',
    subtitle: 'Mise à jour des variables liées au parcours transmission',
    configuration: {
      primaryResidence: 'Veuillez renseigner quel type d\'abattement s\'applique sur la résidence principale :',
      ciotApplication: 'Activation de la gestion de la réponse ministérielle Ciot  :',
      furniturePackage: 'Application du forfait mobilier :'
    }
  },
  modalConfirmation: {
    title: 'Confirmer le scénario',
    cancel: 'Modifier le scénario',
    text: 'Les prochaines étapes seront basées sur ce scénario de transmission. Veuillez confirmer les hypothèses retenues :',
    hypothesisLabel: 'Hypothèse de premier décès:',
    ageLabel: 'Âge lors du décès simulé:',
    age: '{value} ans',
    partnerRights: {
      one_fourth_full_ownership: '25 % en pleine propriété',
      totality_in_usufruct: '100% usufruit',
      available_portion_in_full_ownership: "Quotité disponible en pleine propriété",
      decided_at_death: 'Choix laissé lors du décès',
      hundred_percent_in_full_ownership: '100% en pleine propriété',
      none: 'Aucune',
      three_fourths_usufruct_and_one_fourth_full_ownership: '¾ usufruit et ¼ pleine propriété',
    },
    partnerRightsLabel: 'Option successorale:'
  },
  configuration: {
    title: 'Simuler ma transmission',
    subtitle: 'Définir un scénario de transmission :',
    advanceOptions: 'Options avancées',
    hypothesisChoice: 'Hypothèse premier décès',
    simulationDate: 'Simulation du décès',
    partnerRights: 'Option successorale du survivant',
    partnerRightsHelpMessage: "L’option successorale n’est pas applicable pour un couple marié sous le régime Communauté universelle avec une clause d’attribution intégrale sous condition que tous les biens sont en communauté.",
    disclaimer: 'Les simulations présentées sont réalisées en l\'état de la réglementation en vigueur et au regard des données renseignées sur LCL Mon Patrimoine. Elles ne préjugent pas des évolutions réglementaires et des éléments de votre situation patrimoniale qui pourraient changer d\'ici votre décès. La valeur des biens et des dettes hors LCL, inclus dans le patrimoine transmis, est basée sur l\'estimation du client le jour de la simulation.'
  },
  dataVisualization: {
    indicators: 'Indicateurs',
    indicatorSelection: {
      first: '1er décès: {name}',
      second: '2nd décès: {name}',
      cumulated: 'décès cumulés: {name} puis {partnerName}'
    },
    indicatorTitle: 'Transmission de votre patrimoine',
    graphViewAdvancedTitle: 'Chiffres clés de la transmission',
    graphViewAdvancedSubtitle: 'Vue simplifiée',
    advancedView: {
      transmittablePatrimony: {
        title: 'Patrimoine transmis net de dettes',
        help: 'Valeur de votre patrimoine transmis net de vos dettes , incluant les donations passées et les capitaux décès des contrats d\'assurance-vie et d\'épargne retraite'
      },
      fiscalCost: {
        title: 'Coût fiscal de la transmission',
        help: 'Imposition globale estimée sur votre succession, incluant le coût des donations passées et les prélèvements sur l\'assurance-vie (990 I)'
      },
      netTransmittable: {
        title: 'Patrimoine transmis après impôts',
        help: 'Valeur de votre patrimoine net transmis après paiement du coût fiscal de la transmission',
      },
      fiscalPressure: {
        title: 'Pression fiscale',
        help: 'Part du coût fiscal de la transmission sur le patrimoine net estimé transmis'
      },
      notaryFees: {
        title: 'Frais de notaire estimés',
        help: 'Estimation des frais de notaire à payer en plus du coût fiscal de la transmission'
      },
      more: 'voir plus',
      estateAssets: {
        title: 'Masse successorale',
        help: 'La masse successorale se compose de l\'actif net successoral : les biens laissés par le défunt moins les dettes qui doivent être réglées par les héritiers ainsi que de l\'ensemble des biens donnés par le défunt. Certains biens ne rentrent pas dans la masse successorale comme par exemple les capitaux des contrats d\'assurances-vie et liés aux assurances décès.'
      },
      hereditaryReserve: {
        title: 'Réserve héréditaire',
        help: 'La réserve héréditaire est la fraction des biens dont le défunt ne peut pas disposer librement car la loi la réserve obligatoirement et automatiquement à ses héritiers réservataires (descendants et conjoint). Cette fraction diffère selon le nombre d\'enfants.'
      },
      availableShares: {
        title: 'Quotité disponible',
        help: 'La quotité disponible est constituée par les biens qui ne sont pas réservés et dont le défunt peut librement disposer par donation ou legs. Elle est égale à la masse successorale diminuée des parts réservées. Le défunt a pu l\'attribuer aux personnes qu\'il désirait avantager : un héritier pour conforter sa position, le conjoint ou un non successible (partenaire de PACS, concubin ou tiers)'
      },
      donationDroitsMutationAfterReduction: {
        title: 'Droits de donation déjà payés',
        help: 'Estimation des droits payés sur les donations déjà réalisées'
      },
      lifeInsurance: {
        title: 'Prélèvements sur assurance vie (990 I)',
        help: 'Estimation des prélèvements sur les capitaux décès issus de vos contrats d\'assurance soumis à l\'article 990 I du CGI.'
      },
      successionRights: {
        title: 'Droits de succession',
        help: 'Estimation des droits de succession à payer sur votre patrimoine en cas de décès, y compris les capitaux décès soumis à l\'article 757 B et hors prélèvement selon l\'article 990 I du CGI'
      },
      bruteDeathBenefits: {
        title: 'Capitaux décès des contrats d\'assurance-vie',
        help: 'Capitaux décès issus des contrats d\'assurance-vie et d\'épargne retraite avant prélèvements (article 990 I du CGI) le cas échéant'
      }
    },
    coverageGraph: {
      title: 'Couverture du coût de la transmission',
      subtitle: 'Estimation par personne bénéficiaire',
      notaryFees: 'Frais de notaire',
      successionRights: 'Droits de succession',
      liquidities: 'Liquidités',
      categoryTitle: 'Couverture: {percent}'
    },
    repartitionData: {
      title: 'Répartition de la transmission',
      help: 'La valeur des biens et capitaux décès reçus en usufruit ou en nue propriété est exprimée en valeur pleine propriété.',
      patrimony: {
        title: 'Patrimoine hors contrats d\'assurance',
        estateAssets: 'Masse successorale',
        transmittedViaDonation: 'Transmis par donation',
        transmittedViaSuccession: 'Transmis par succession',
        usufructBareOwnershipReunion: 'Réunion usufruit - nue propriété',
        fullOwnership: 'Transmis par succession - Pleine propriété',
        usufruct: 'Transmis par succession - Usufruit',
        bareOwnership: 'Transmis par succession - Nue propriété',
        successionRights: 'Droits de succession',
      },
      asv: {
        title: 'Contrats d\'assurance-vie et d\'épargne retraite',
        lifeInsurance: 'Assurance vie',
        fullOwnership: 'Capitaux décès reçus en pleine propriété',
        usufruct: 'Capitaux décès reçus en usufruit',
        bareOwnership: 'Capitaux décès reçus en nue-propriété',
        totalDeathBenefits: 'Capitaux décès reçus'
      },
      costs: {
        title: 'Coûts de la transmission',
        donationRights: 'Droits de donation',
        successionRights: 'Droits de succession',
        deducedDeathBenefits: 'Prélèvements sur capitaux décès de l\'assurance-vie (990 I)',
        estimatedNotaryFees: 'Frais de notaire estimés',
        totalCostOfTransmission: 'Coût total de la transmission'
      },
      synthesis: {
        deceasedFullProperty: 'Décès - Pleine propriété',
        deceasedUsufruct: 'Décès - Usufruit',
        deceasedBareProperty: 'Décès - Nue propriété',
        transmittedViaDonation: 'Donation',
        totalCostOfTransmission: 'Coût total de la transmission',
        deceased: 'Décès',
      }
    }
  }
}
